<script lang="ts">
	import { Device, DeviceGroup, DeviceRPi } from "luxedo-data"
	import { Reactivity } from "luxedo-reactivity"

	interface Props {
		device: Device
	}

	let { device }: Props = $props()

	let childDevices: Array<DeviceRPi> = $derived.by(() => {
		if (!(device instanceof DeviceGroup)) return []
		return device.getChildDevices()
	})

	$effect.pre(() => {
		Reactivity.useProps(device, ["color"])
	})

	let deviceColor = $derived(Reactivity.propOf(device, "color"))
</script>

<div class="icon-bg"></div>

{#if device instanceof DeviceGroup && childDevices.length === device.children.length}
	{#each childDevices as d}
		<div style="background-color: {d && 'color' in d ? d.color : ''}" class="icon-bg-color"></div>
	{/each}
{:else}
	<div style="background-color: {deviceColor}" class="icon-bg-color"></div>
{/if}

<style>
	.icon-bg {
		position: absolute;
		width: 500%;
		height: 500%;
		backdrop-filter: blur(2rem);
		z-index: -1;
	}

	.icon-bg-color {
		position: absolute;
		width: 2rem;
		height: 2rem;
		border-radius: 100%;
		z-index: -2;
	}
</style>
